var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-icon",class:{ ring: _vm.showRing },style:(_vm.computedStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }